import angular from 'angular';
import regulatorListComponent from './regulator-list.component';

export default angular.module('components.app.account.regulator-list', [])
  .component('regulatorList', regulatorListComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/companies/regulator-list/regulator-list.module.js